import React from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Table,
  Tag,
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";

import {
  accessType,
  convertDateTime
} from '../../../../../utils/common'

const TableData = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation()
  const {
    loading = false,
    className = '',
    data = [],
    params = {},
  } = props;

  const columns = [
    {
      title: t('common.no'),
      dataIndex: 'stt',
      key: 'stt',
      align: 'center',
      width: 80,
    },
    {
      title: t('access_key.id'),
      dataIndex: 'access_key_id',
      key: 'access_key_id',
      align: 'left',
      width: 300,
      render: (_, record) => <TextCopy
        value={record.access_key_id}
      />
    },
    {
      title: t('common.ip_address'),
      dataIndex: 'ip',
      key: 'ip',
      align: 'left',
      width: 200,
      render: (_, record) => <TextCopy
        value={record.ip}
      />
    },
    {
      title: t('common.access_type'),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      width: 200,
      render: (_, record) => <Tag color={accessType(record.type).color}>
        <TextCopy
          value={t(accessType(record.type).label)}
        />
      </Tag>
    },
    {
      title: t('access_log.access_time'),
      dataIndex: 'creation_date',
      key: 'creation_date',
      align: 'center',
      width: 250,
      render: (_, record) => <TextCopy
        value={convertDateTime(record.creation_date)}
        align={'center'}
      />
    },
    {
      title: t('common.location'),
      dataIndex: 'location',
      key: 'location',
      align: 'left',
      width: 150,
      render: (_, record) => <TextCopy
        value={record.location}
      />
    },
    {
      title: t('common.client'),
      dataIndex: 'client',
      key: 'client',
      align: 'left',
      width: 300,
      render: (_, record) => <TextCopy
        limited={false}
        value={record.client}
      />
    },
  ]

  return (
    <Table
      className={className}
      columns={columns}
      dataSource={data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))}
      loading={loading}
      pagination={false}
      rowKey={(record) => record?.id}
      size="small"
      scroll={{ x: 1024 }}
    />
  );
}

export default TableData;
